import { PopperButton } from "../../../../common/components/popper_button";
import { ObrasCommonReportsState } from "./hooks/obras_common_reports";

/**
 * ObrasReportButton
 */

type Props = {
  state: ObrasCommonReportsState;
};

export const ObrasReportButton = ({
  state,
}: Props) => {
  return (
    <>
      <div className="w-[7rem]">
        <PopperButton
          buttonLabel='Relatórios'
          buttonColor='yellow'
          options={state.popperRelatorio}
          onSelect={state.handlePopperRelatorioSelect}
        />
      </div>
    </>
  );
}